const mixcontent = {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    cols: {
      type: Array,
      default: () => []
    },
    dateCols: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      labels: [],
      values: [],
      content: '',
      showContent: ''
    }
  },
  methods: {
    getLabel(label) {
      return `&nbsp;<span style="background-color: #f5f5f5; font-size:0.95rem; padding: 4px 10px; border: 1px solid #eaeaea; border-radius: 4px;">${label}</span>&nbsp;`
    }
  }
}

export default mixcontent
